// export const serverUrl = process.env.REACT_APP_SERVER_URL;
export const serverUrl =
  process.env.NODE_ENV === 'development' ? 'http://localhost:3001/api' : 'https://gotobed.eu/api';

// default routerUrls is routerUrls_BG
export const routerUrls = {
  root: '/',
  sale: '/namalenie',
  product: '/produkt',
  products: '/produkti',
  productsCategories: '/kategorii',
  adultCategories: '/kategorii',
  kidsCategories: '/kategorii/za-deca',
  cottonSatinCategories: '/kategorii/spalno-belio/pamuchen-saten',
  search: '/tursene',
  cart: '/koshtnitsa',
  checkout: '/checkout',
  orderPlaced: '/poruchkata-zavurshena',
  // footer pages
  contacts: '/kontakti',
  contactForm: '/forma-za-kontakti',
  deliveryInfo: '/dostavka-na-stokite',
  paymentMethods: '/nachini-za-plashtane',
  privacyPolicy: '/deklaratsiq-za-poveritelnost',
  returnForm: '/forma-za-vrushtane',
  returnInfo: '/vrushtane-na-zakupena-stoka',
  sizingGuides: '/tablitsi-s-razmeri',
  termsAndConditions: '/obshti-usloviq',
  usefulInfo: '/polezna-informaciq',
  submittedForm: '/forma-izpratena',
  blog: '/blog'
};

// Top-level menu categories have stable database ids. Keeping their landing-page
// destinations here lets desktop and mobile navigation use the same routes.
export const categoryLandingRoutesById = {
  1: routerUrls.adultCategories,
  2: routerUrls.kidsCategories
};

export const WEBSITE_URL = 'https://www.gotobed.eu';

export const routerUrls_EN = {
  root: '/',
  sale: '/sale',
  product: '/product',
  products: '/products',
  productsCategories: '/productsCategories',
  adultCategories: '/categories/for-adults',
  kidsCategories: '/categories/for-kids',
  cottonSatinCategories: '/categories/bed-linen/cotton-sateen',
  search: '/search-results',
  cart: '/cart',
  checkout: '/checkout',
  orderPlaced: '/order-placed',
  // footer pages
  contacts: '/contacts',
  contactForm: '/contact-form',
  deliveryInfo: '/delivery-information',
  paymentMethods: '/payment-methods',
  privacyPolicy: '/privacy-policy',
  returnForm: '/return-form',
  returnInfo: '/return-information',
  sizingGuides: '/sizing-guides',
  termsAndConditions: '/terms-and-conditions',
  usefulInfo: '/useful-information',
  submittedForm: '/submitted-form',
  blog: '/blog'
};

export const routerUrls_RU = {
  root: '/',
  sale: '/sale',
  product: '/product',
  products: '/products',
  productsCategories: '/productsCategories',
  adultCategories: '/categories/for-adults',
  kidsCategories: '/categories/for-kids',
  cottonSatinCategories: '/categories/bed-linen/cotton-sateen',
  search: '/search-results',
  cart: '/cart',
  checkout: '/checkout',
  orderPlaced: '/order-placed',
  // footer pages
  contacts: '/contacts',
  contactForm: '/contact-form',
  deliveryInfo: '/delivery-information',
  paymentMethods: '/payment-methods',
  privacyPolicy: '/privacy-policy',
  returnForm: '/return-form',
  returnInfo: '/return-information',
  sizingGuides: '/sizing-guides',
  termsAndConditions: '/terms-and-conditions',
  usefulInfo: '/useful-information',
  submittedForm: '/submitted-form',
  blog: '/blog'
};

export const deviceSize = {
  xs: 425,
  sm: 768,
  md: 1024,
  lg: 1440
};

export const layoutConstant = {
  topbarHeight: 40,
  grocerySidenavWidth: 280,
  containerWidth: 1200,
  mobileNavHeight: 64,
  headerHeight: 80,
  mobileHeaderHeight: 64
};

export const themeColors = {
  darkBlue: '#0c0e30',
  cherryRedBright: '#d64444',
  cherryRedDeep: '#a4014e',

  //dark royal purple
  darkPurple: '#68478D',

  //home squares
  lightYellow: '#f4d96e',
  lightBlue: '#8acee2',
  lightGreen: '#a7c083',
  lightPurple: '#8695bb',

  gunMetalGrey: '#818589'
};

export const stringConstants = {
  email: 'info@gotobed.eu',
  phone: '+359 888 936 738',
  workingHours: 'Пон-Пет 10:00-18:00'
};

// The chat buttons ring the same line as the topbar, so the deep links are derived from
// `stringConstants.phone` rather than written down a second time and left to drift.
const phoneDigits = stringConstants.phone.replace(/\D/g, '');

export const messengerUrls = {
  // wa.me is WhatsApp's own short link: it hands off to the app on a phone and to
  // web.whatsapp.com on a desktop. Digits only - no "+", no spaces.
  whatsapp: `https://wa.me/${phoneDigits}`,
  // Viber has no https equivalent, only the app scheme. The leading "+" has to be
  // percent-encoded or the query string delivers it to the app as a space.
  viber: `viber://chat?number=%2B${phoneDigits}`
};

// Shown only when a viber:// click goes unanswered, i.e. the app is not on the device.
export const viberDownloadUrl = 'https://www.viber.com/en/download/';

// The payment options offered at checkout. Named here rather than only in Checkout.jsx because
// the thank-you page has to recognise the bank-transfer order to show the account details.
export const paymentTypes = {
  cashOnDelivery: 'Плащане при доставка.(в брой/банкова карта)',
  bankTransfer: 'Банков превод'
};

// The one place the account is written down: the thank-you page, "Начини за плащане" and the
// payment clause of "Общи условия" all render these values.
export const bankDetails = {
  iban: 'BG70UBBS81551012052738',
  bic: 'UBBSBGSF',
  bank: 'ОББ',
  holder: 'Мина Актуал Про ЕООД'
};

export const socialUrls = {
  facebook: 'https://www.facebook.com/gotobed.eu',
  instagram: 'https://www.instagram.com/gotobed.eu/'
};

export const languages = {
  bg: 'bg',
  en: 'en',
  ru: 'ru'
};

export const assets = {
  logo: 'https://gotobed.eu/wp-content/uploads/files/logo/gotobedlogo_1_50.png',
  logoWhite: 'https://gotobed.eu/wp-content/uploads/files/logo/gotobedlogo-white_1_2_50.png',
  standardSizingGuide:
    'https://gotobed.eu/wp-content/uploads/files/msc/standard-sizes-2048x978.jpg',
  sizingGuideFittedSheets:
    'https://gotobed.eu/wp-content/uploads/files/msc/RUKOVOD-SHEET-CVETNO-1000.jpg',
  sizingGuideDuvetCover:
    'https://gotobed.eu/wp-content/uploads/files/msc/PLIK-RUKOVOD-CVQT-1200.jpg',
  sizingGuidePillowCase: 'https://gotobed.eu/wp-content/uploads/files/msc/SIZING-GUIDE.jpg'
};

export const currency = {
  EUR: 'EUR'
};

// Delivery fees are maintained and displayed in EUR only.
const createDeliveryOption = (name, price_eur) =>
  Object.freeze({
    name,
    price_eur
  });

export const DELIVERY_OPTIONS = Object.freeze({
  econtOffice: createDeliveryOption('ЕКОНТ Офис ', '3.99'),
  speedyOffice: createDeliveryOption('СПИДИ Офис ', '2.99'),
  address: createDeliveryOption('До Адрес', '4.55')
});

export const DELIVERY_OPTIONS_LIST = Object.freeze(Object.values(DELIVERY_OPTIONS));
